import './bootstrap';
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { Layout } from 'laravel-inertia-backend';
import './bootstrap';
import '../scss/app.scss';
import { LaravelReactI18nProvider } from 'laravel-react-i18n';
import menu from "./menu.js";

createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.jsx', { eager: true });
        console.log(pages);
        let page = pages[`./Pages/${name}.jsx`]
        page.default.layout =
            name.startsWith("Auth/") || name == "Welcome"
                ? undefined
                : (page) => <Layout
                    menuEntries={menu}
                    title="SplitCare"
                    titleElement={(<h1>SplitCare</h1>)}
                    sidebarBottomComponent={(<>Version: 0.0.1</>)}
                    children={page} />;
        return page
    },
    setup({ el, App, props }) {
        createRoot(el).render(<LaravelReactI18nProvider
            locale={'de'}
            fallbackLocale={'en'}
            files={import.meta.glob('/resources/lang/*.json')}
        ><App {...props} />
        </LaravelReactI18nProvider>
        )
    },
})
